module.exports = __webpack_public_path__ + "img/story007.ea3c9307.webp";